import React from 'react';
import Container from './Container';

/*
 * Major page section with the §4 vertical rhythm. Pass `id` for in-page anchors
 * (#about / #services / #contact). Set `contained={false}` for full-bleed content.
 */
export default function Section({ id, className = '', contained = true, children, ...rest }) {
  return (
    <section id={id} className={`section${className ? ` ${className}` : ''}`} {...rest}>
      {contained ? <Container>{children}</Container> : children}
    </section>
  );
}
